import $ from "jquery";
import _ from "lodash";
import { ajax } from "./ajax";
import { dialogs } from "../components/dialogs";
import { getSelectedIds } from "../components/checkedList";
import { lowerCase, startCase, toPlural } from "../technical/strings";
const warnAboutSelected = (checkedListEntityName) => {
    dialogs.showDialog("alert", {
        title: `No ${startCase(toPlural(checkedListEntityName))} selected.`,
        message: `Please select at least one ${lowerCase(checkedListEntityName)}.`,
    });
};
const ajaxAction = async (e) => {
    const target = $(e.currentTarget);
    const url = target.data("ajax-url");
    const method = target.data("ajax-method");
    const title = target.data("ajax-confirmation-title");
    const message = target.data("ajax-confirmation-message");
    const checkedListSelector = target.data("ajax-checkedlist");
    const checkedListEntityName = target.data("ajax-entity");
    const showModal = target.is("[data-ajax-show-modal]");
    const blockUi = target.is("[data-ajax-block-ui]");
    let data;
    if (checkedListSelector && checkedListEntityName) {
        const ids = getSelectedIds(checkedListSelector);
        if (!_.some(ids)) {
            warnAboutSelected(checkedListEntityName);
            return;
        }
        data = { ids };
    }
    if (message) {
        const response = await dialogs.showDialog("confirmation", { message, title });
        if (response.result === "negative")
            return;
    }
    ajax({
        url,
        method,
        showModal,
        data,
        blockUi,
    });
};
$(document).on("click", "[data-ajax-url]", ajaxAction);
